import DataTableV2ItemViewMobile from '@/agilis/mobile/DataTableV2ItemViewMobile/DataTableV2ItemViewMobile.js'
import PriceItemTableView from '@/applications/sales/components/PriceItemTable/datatable/PriceItemTableView'

export default {
  name: 'PriceItemTableViewMobile',
  mixins: [DataTableV2ItemViewMobile, PriceItemTableView]
}
